import { IFiltersClientErrors } from '../../../types/filters';

export const defaultState: IFiltersClientErrors = {
  geo: null,
};
